import React from "react";
import { Star, Fire } from "@phosphor-icons/react";

export default function LevelCard({ progress, compact = false }) {
  if (!progress) return null;
  const { level, streak_days } = progress;
  const pct = level?.progress_pct ?? 0;
  return (
    <div className={`bg-brand-ink text-white rounded-3xl p-5 shadow-lg ${compact ? "" : "mb-5"}`} data-testid="level-card">
      <div className="flex items-center gap-3">
        <div className="w-12 h-12 rounded-2xl bg-brand-primary flex items-center justify-center flex-shrink-0">
          <Star size={26} weight="fill" color="#1D3557" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2">
            <span className="font-outfit font-extrabold text-lg leading-none">Seviye {level.level}</span>
            <span className="font-nunito text-sm text-white/70">·</span>
            <span className="font-nunito font-semibold text-sm text-brand-primary truncate">{level.title}</span>
          </div>
          <div className="text-xs font-nunito text-white/70 mt-1" data-testid="level-xp-text">
            {level.xp_in_level} / {level.xp_to_next} XP
          </div>
        </div>
        {streak_days >= 1 && (
          <div className="flex items-center gap-1 bg-white/10 rounded-full px-3 py-1.5" data-testid="streak-chip">
            <Fire size={16} weight="fill" color="#FFB703" />
            <span className="font-outfit font-bold text-sm">{streak_days}</span>
          </div>
        )}
      </div>
      <div className="mt-3 h-2 bg-white/15 rounded-full overflow-hidden">
        <div
          className="h-full bg-brand-primary transition-all duration-500 rounded-full"
          style={{ width: `${pct}%` }}
          data-testid="level-progress-bar"
        />
      </div>
    </div>
  );
}
